import React from 'react'
import PropTypes from 'prop-types'

import CopyBlock from './CopyBlock'
import MediaBlock from './MediaBlock'
import { SectionContainer, MobileMediaWrapper, DesktopMediaWrapper } from './styles'

export default function TextAndMediaBlock({
  heading,
  description,
  useBullets = false,
  descriptionList = [],
  useCTA,
  resourceUrl,
  isVideo,
  isVideoEmbed,
  textLeft,
  ctaText,
  ctaFontSize = 'medium',
  ctaUseFullWidth = false,
  ctaLink,
  ctaBackgroundColor = 'coral',
  ctaVariant,
  ctaAnalytics,
  altText,
  backgroundColor,
}) {
  return (
    <SectionContainer bkgColor={backgroundColor}>
      <MobileMediaWrapper>
        <MediaBlock
          resourceUrl={resourceUrl}
          altText={altText}
          isVideo={isVideo}
          isVideoEmbed={isVideoEmbed}
        />
      </MobileMediaWrapper>
      {textLeft ? (
        <>
          <CopyBlock
            heading={heading}
            useBullets={useBullets}
            descriptionList={descriptionList}
            description={description}
            useCTA={useCTA}
            ctaText={ctaText}
            ctaFontSize={ctaFontSize}
            ctaUseFullWidth={ctaUseFullWidth}
            ctaLink={ctaLink}
            ctaBackgroundColor={ctaBackgroundColor}
            ctaVariant={ctaVariant}
            ctaAnalytics={ctaAnalytics}
            textLeft={textLeft}
          />
          <DesktopMediaWrapper>
            <MediaBlock
              resourceUrl={resourceUrl}
              altText={altText}
              isVideo={isVideo}
              isVideoEmbed={isVideoEmbed}
            />
          </DesktopMediaWrapper>
        </>
      ) : (
        <>
          <DesktopMediaWrapper>
            <MediaBlock
              resourceUrl={resourceUrl}
              altText={altText}
              isVideo={isVideo}
              isVideoEmbed={isVideoEmbed}
            />
          </DesktopMediaWrapper>
          <CopyBlock
            heading={heading}
            useBullets={useBullets}
            descriptionList={descriptionList}
            description={description}
            useCTA={useCTA}
            ctaText={ctaText}
            ctaFontSize={ctaFontSize}
            ctaUseFullWidth={ctaUseFullWidth}
            ctaLink={ctaLink}
            ctaBackgroundColor={ctaBackgroundColor}
            ctaVariant={ctaVariant}
            ctaAnalytics={ctaAnalytics}
          />
        </>
      )}
    </SectionContainer>
  )
}

TextAndMediaBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  useBullets: PropTypes.bool.isRequired,
  descriptionList: PropTypes.array.isRequired,
  useCTA: PropTypes.bool.isRequired,
  resourceUrl: PropTypes.string.isRequired,
  isVideoEmbed: PropTypes.bool.isRequired,
  isVideo: PropTypes.bool.isRequired,
  textLeft: PropTypes.bool.isRequired,
  ctaText: PropTypes.string,
  ctaFontSize: PropTypes.string,
  ctaUseFullWidth: PropTypes.bool,
  ctaLink: PropTypes.string,
  ctaBackgroundColor: PropTypes.string,
  ctaVariant: PropTypes.bool,
  ctaAnalytics: PropTypes.string,
  altText: PropTypes.string,
  backgroundColor: PropTypes.string,
}
